import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon, StarIcon } from 'lucide-react';
export interface Testimonial {
  name: string;
  location: string;
  quote: string;
}
interface TestimonialsProps {
  testimonials: Testimonial[];
}
export function Testimonials({
  testimonials
}: TestimonialsProps) {
  return <section className="bg-paper px-4 py-20 md:py-28" data-id="element-203" data-mp="3azjetzqo6od9">
      <div className="mx-auto max-w-6xl" data-id="element-204" data-mp="36yzhav26piql">
        <div className="mx-auto max-w-2xl text-center" data-id="element-205" data-mp="3700up66oahbh">
          <p className="text-sm font-bold uppercase tracking-[0.15em] text-clay-dark" data-id="element-206" data-mp="31zw9x3yqf0fg">Experiencias de alumnos</p>
          <h2 className="mt-3 font-heading text-4xl font-semibold text-ink md:text-5xl" data-id="element-207" data-mp="2x09vwsb2xg5l">
            Un proceso que se siente paso a paso
          </h2>
        </div>

        <div className="mt-12 grid gap-5 md:grid-cols-3" data-id="element-208" data-mp="2s3t5frgeqppc">
          {testimonials.map((testimonial, index) => <motion.figure key={testimonial.name} initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.45,
          delay: index * 0.1
        }} className="flex min-h-72 flex-col rounded-2xl border border-clay/15 bg-white p-7 shadow-sm" data-id="element-209" data-mp="v72ijof118mc" data-mpi={index}>
              <div className="flex items-center justify-between" data-id="element-210" data-mp="c6ve5o6cmp9w">
                <div className="flex gap-1 text-clay-dark" aria-label="5 de 5 estrellas" data-id="element-211" data-mp="c73rtiaapym5">
                  {Array.from({
                length: 5
              }, (_, star) => <StarIcon key={star} className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-212" data-mp="14vskqu176xmt" />)}
                </div>
                <QuoteIcon className="h-6 w-6 text-rose" aria-hidden="true" data-id="element-213" data-mp="q5v0uqaawu3f" />
              </div>
              <blockquote className="mt-7 flex-1 font-heading text-2xl font-semibold leading-snug text-ink" data-id="element-214" data-mp="v4ep4xcdahyy">
                “{testimonial.quote}”
              </blockquote>
              <figcaption className="mt-7 border-t border-clay/15 pt-4 text-sm font-bold text-clay-dark" data-id="element-215" data-mp="1nmk1ignilqb8">
                {testimonial.name} <span className="font-medium text-ink/55" data-id="element-216" data-mp="1xgplhfziqya6">— {testimonial.location}</span>
              </figcaption>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}